<template>
  <div class="app">
    <Header>
      <div class="header_top ban">
        <div class="logo">
          <a href="http://www.sh-shelf.com/">
            <img src="../../assets/img/logo.png" />
          </a>
          <h1>
            <a href="#">{{ $t('locale.cname') }}</a>
          </h1>
        </div>
        <div class="header_login">
          <li>
            <i class="inex_login"></i>
            <template v-if="isLogin">
              <a href="/mall/myorder.html" class="register-mark Showcombobox">
                {{ mobile }}
                <div class="combobox">
                  <div class="combobox_div">
                    <a href="/mall/myorder.html">{{ $t('locale.myorder') }}</a>
                  </div>
                  <div class="combobox_div">
                    <a href="/mall/car.html">{{ $t('locale.car') }}</a>
                  </div>
                  <div class="combobox_div">
                    <a href="/mall/myplan.html">{{ $t('locale.myplan') }}</a>
                  </div>
                  <div class="combobox_div">
                    <a href="/mall/coupon.html">{{ $t('locale.coupon') }}</a>
                  </div>
                  <div class="combobox_div">
                    <a href="/" @click="isLogout">{{ $t('locale.logout') }}</a>
                  </div>
                </div>
              </a>
              <span class="xiexian">|</span>
              <a href="javascript:;" class="register-mark" @click="isLogout">{{ $t('locale.louout1') }}</a>
            </template>
            <template v-else>
              <a href="#" class="register-mark"></a>
              <!-- <a href="javascript:;" class="register-mark js-logout">登出</a> -->
              <a href="/page/register" class="register-mark">{{ $t('locale.register') }}</a>
              <span class="xiexian">|</span>
              <a href="/page/login" class="register-mark">{{ $t('locale.login') }}</a>
            </template>
          </li>
          <!-- <b></b> -->
          <li>
				<i class="car_icon1"></i>
				<a class="local-active" href="/mall/goods.html" >{{ $t('locale.online_shop') }}</a>
		  </li>
          <li>
            <i class="inex_map"></i>
            <a v-if="local === 'zh'" class="local-active" href="javascript:;" data-locale="zh" @click="i18n('zh')">简体中文</a>
            <a v-else class="local-unactive" href="javascript:;" data-locale="zh" @click="i18n('zh')">简体中文</a>
             <span class="zhixian">|</span>
            <a v-if="local === 'en'" class="local-active" href="javascript:;" data-locale="en" @click="i18n('en')">English</a>
            <a v-else class="local-unactive" href="javascript:;" data-locale="en" @click="i18n('en')">English</a> 
          </li>
        </div>
      </div>
    </Header>
    <div class="header_bottom" style="display: none;">
      <div class="header_nav ban" style="padding-left: 150px;">
        <!--<li>
          <a class="header_nav_a" href="/">{{ $t('locale.home') }}</a>
        </li>-->
        <li>
          <a class="header_nav_a" href="#">{{ $t('locale.about') }}</a>
          <div class="Dropdown">
            <dd>
              <a href="/page/about">{{ $t('locale.about1') }}</a>
            </dd>
            <dd>
              <a href="/page/about-culture">{{ $t('locale.about_culture') }}</a>
            </dd>
            <dd>
              <a href="/page/about-step">{{ $t('locale.about_step') }}</a>
            </dd>
            <dd>
              <a href="/page/about-productive">{{ $t('locale.about_productive') }}</a>
            </dd>
            <dd>
              <a href="/page/about-authority">{{ $t('locale.about_authority') }}</a>
            </dd>
            <dd>
              <a href="/page/about-partner">{{ $t('locale.about_partner') }}</a>
            </dd>
          </div>
        </li>
        <li>
			<a class="header_nav_a" href="#">{{ $t('locale.Commercial_retail') }}</a>
			<div class="Dropdown">
				<dd>
					<a href="/page/schj">{{ $t('locale.shelves') }}</a>
				</dd>
				<dd>
					<a href="/page/hyzmchj">{{ $t('locale.store_shelves') }}</a>
				</dd>
				<dd>
					<a href="/page/zsdj">{{ $t('locale.stage') }}</a>
				</dd>
				<dd>
					<a href="/page/gwc">{{ $t('locale.car') }}</a>
				</dd>
			</div>
		</li>
		<li>
			<a class="header_nav_a" href="#">{{ $t('locale.warehousing_industry') }}</a>
			<div class="Dropdown">
				<dd>
					<a href="/page/hlshj">{{ $t('locale.beam_type_shelves') }}</a>
				</dd>
				<dd>
					<a href="/page/hlshj?type=2">{{ $t('locale.narrow_roadway_beam_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/hlshj?type=3">{{ $t('locale.double_depth_beam_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/mjcchj">{{ $t('locale.drive_in_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/mjcchj?type=2">{{ $t('locale.shuttle_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/gyhj">{{ $t('locale.flow_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/gyhj?type=2">{{ $t('locale.cantilever_rack_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/gyhj?type=3">{{ $t('locale.duty_racking_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/gyhj?type=4">{{ $t('locale.attic_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/lthj">{{ $t('locale.vertical_warehouse_shelves') }}</a>
				</dd>
                <dd>
					<a href="/page/wlsb">{{ $t('locale.logistics_equipment') }}</a>
				</dd>
			</div>
		</li>
        <!--<li>
          <a class="header_nav_a" href="#">{{ $t('locale.solution') }}</a>
          <div class="Dropdown">
            <dd>
              <a href="/page/retail">{{ $t('locale.retail') }}</a>
            </dd>
            <dd>
              <a href="/page/stage">{{ $t('locale.stage') }}</a>
            </dd>
            <dd>
              <a href="/page/storage">{{ $t('locale.storage') }}</a>
            </dd>
            <dd>
              <a href="/page/vending">{{ $t('locale.vending') }}</a>
            </dd>
          </div>
        </li>
        <li>
          <a class="header_nav_a" href="#">{{ $t('locale.online_shop') }}</a>
          <div class="Dropdown">
            <dd>
              <a href="/page/design">{{ $t('locale.design') }}</a>
            </dd>
            <dd>
              <a href="/mall/goods.html">{{ $t('locale.online_shop') }}</a>
            </dd>
            <dd
              v-for="(item,index)  in mycustomer"
              :key="item.id"
            >
              <a :href=" item.url">{{ item.name }}</a>
            </dd>
          </div>
        </li>-->
        <li>
          <a class="header_nav_a" href="#">{{ $t('locale.server') }}</a>
          <div class="Dropdown">
            <dd>
              <a href="/page/serve">{{ $t('locale.serve') }}</a>
            </dd>
            <dd>
              <a href="/page/serve-shop">{{ $t('locale.serve_shop') }}</a>
            </dd>
          </div>
        </li>
        <li>
          <a class="header_nav_a" href="#">{{ $t('locale.contactus') }}</a>
          <div class="Dropdown">
            <dd>
              <a href="/page/contact">{{ $t('locale.contact') }}</a>
            </dd>
            <dd>
              <a href="/page/jobs">{{ $t('locale.jobs') }}</a>
            </dd>
            <dd>
              <a href="/page/agent">{{ $t('locale.agent') }}</a>
            </dd>
            <dd>
              <a href="/page/supplier">{{ $t('locale.supplier') }}</a>
            </dd>
          </div>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cell",
  data() {
    return {
      isLogin: false,
      local: 'zh',
      mobile: "",
      mycustomer:[]
    };
  },
  methods: {
    getUser: async function() {
      const res = await this.$http.get("/api/userinfo");

      if (res.data.mobile || res.data.nickname) {
        this.isLogin = true;
        //this.mobile = "****" + res.data.mobile.substr(7, 4);
        this.mobile = res.data.nickname;
        this.local = res.data.local;
      }
    },
    getMyCustomer: async function() {
      const res = await this.$http.get("/api/photo/mycustomer");

      this.mycustomer = res.data;
      
    },
    i18n: async function(local) {
      this.lang = localStorage.getItem('locale') || 'zh';
   
      if ( this.lang === 'zh' ) {
       this.lang = 'en';
       this.$i18n.locale = this.lang;
      } else {
       this.lang = 'zh';
       this.$i18n.locale = this.lang;
      }
      localStorage.setItem('locale', this.lang);
      
      const res = await this.$http.get("/api/setLocale?locale="+local);
      this.local = local;
      location.reload();
      
      
    },
    isLogout: async function() {
      const res = await this.$http.get("/api/logout");
      if (res.code == 200) {
        this.isLogin = false;
        location.reload();
      }
    }
  },
  mounted() {
    this.getUser();
    this.getMyCustomer();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ban {
  width: 1200px;
  margin: 0 auto;
}
header {
  width: 100%;
  height: 90px;
}
.header_top {
  vertical-align: middle;
}
.logo {
  float: left;
  width: 173px;
  height: 55px;
  background-size: 100%;
  font-size: 0;
  margin: 19px 0 16px 0;
}
.logo a {
  display: block;
  width: 100%;
  height: 100%;
}
.logo img {
  width: 100%;
  height: 100%;
}
.logo h1 {
  font-size: 0;
}
.header_bottom {
  width: 100%;
  height: 60px;
}
.header_nav {
  height: 60px;
  position: relative;
}
.header_nav_a {
  display: block;
  width: 100%;
  height: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header_nav li {
  float: left;
  width: 150px;
  height: 60px;
  display: flex;
  align-items: center;
  margin-right: 30px;
  font-size: 16px;
}
.header_nav li:hover {
  background-color: #cc4a49;
}
.header_nav li:hover a {
  color: #fff;
}
.header_nav li:hover .Dropdown {
  visibility: visible;
}
.header_nav li a {
  /* //width: 64px; */
  height: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin: 0 auto;
}
.header_login {
  float: right;
  display: flex;
  align-items: center;
}

.combobox {
  position: absolute;
  top: 90px;
  left: 0;
  width: 110px;
  height: 200px;
  background-color: #ccc;
  margin: 0;
  padding: 0;
  z-index: 99;
  display: none;
}
.Showcombobox:hover .combobox {
  display: block;
}
.combobox div {
  width: 100%;
  height: 50px;
  background-color: #fff;
}
.combobox div a {
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  background-color: #fff;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  color: #262626;
  margin-top: 0 !important;
}
.combobox div a:hover {
  background: #cc4a49;
  opacity: 1;
  color: #fff;
}
.header_login li {
  position: relative;
  float: left;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  vertical-align: text-bottom;
}
.header_login li a {
  display: inline-block;
  display: flex;
  height: 100%;
  align-items: center;
}
.header_login li:nth-child(2) {
  margin-left: 73px;
}
.inex_login {
  display: inline-block;
  width: 21px;
  height: 20px;
  margin-right: 8px;
  background: url(../../assets/img/index_user.png) no-repeat center center;
  background-size: 18px 18px;
}
.inex_map {
  display: inline-block;
  width: 21px;
  height: 21px;
  margin-right: 8px;
  background: url(../../assets/img/index_map.png) no-repeat center center;
  background-size: 18px 18px;
}
.register-mark {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* // line-height: 24px; */
  line-height: 24px;
}
.login-mark {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(159, 160, 160, 1);
  line-height: 24px;
}
.local-active {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
.local-unactive {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(159, 160, 160, 1);
  line-height: 24px;
}
.xiexian {
  margin: 0 8px;
}
.zhixian {
  display: inline-block;
  margin: 0 8px;
}

.header_nav li:hover .Dropdown {
  visibility: visible;
}
.Dropdown {
  position: absolute;
  width: 150px;
  top: 60px;
  z-index: 999;
  visibility: hidden;
}
.Dropdown dd {
  width: 150px;
  height: 30px;
  background: rgba(204, 74, 73, 0.74);
  border: 1px solid rgba(255, 255, 255, 0.17);
  text-align: center;
  opacity: 0.68;
}

.Dropdown dd a {
  display: block;
  width: 110px;
  height: 30px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  padding-top: 5px;
}
.Dropdown dd:hover {
  background-color: rgba(204,74,73,1);;
  color: #fff;
  opacity: 1;
}
.header_nav li:hover .Dropdown dd:first-of-type {
  animation: menu6 0.2s ease-in-out forwards;
  animation-delay: 0.2s;
}

.header_nav li:hover .Dropdown dd:nth-of-type(2) {
  animation: menu6 0.2s ease-in-out forwards;
  animation-delay: 0.4s;
}

.header_nav li:hover .Dropdown dd:nth-of-type(3) {
  animation: menu6 0.2s ease-in-out forwards;
  animation-delay: 0.6s;
}

.header_nav li:hover .Dropdown dd:nth-of-type(4) {
  animation: menu6 0.2s ease-in-out forwards;
  animation-delay: 0.8s;
}
.header_nav li:hover .Dropdown dd:nth-of-type(5) {
  animation: menu6 0.2s ease-in-out forwards;
  animation-delay: 1s;
}
.header_nav li:hover .Dropdown dd:nth-of-type(6) {
  animation: menu6 0.2s ease-in-out forwards;
  animation-delay: 1.2s;
}

@keyframes menu6 {
  0% {
    transform: rotateX(-90deg);
  }
  100% {
    transform: rotateX(0);
  }
}
dd {
  margin-left: 0;
}

.header_login li:nth-child(2) {
    margin-left: 33px;
}
.header_login li:nth-child(3) {
    margin-left: 33px;
}
.header_login .car_icon1{
    height: 18px;
    width: 18px;
    background-size: 18px 18px;
    margin-bottom: 0;
    margin-right: 7px;
    background-image: url(/assets/prod/img/car.png);
}
.header_login i{
    position: relative;
    top: -2px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue